import assignMergeValue from "./component-library373.mjs";
import cloneBuffer from "./component-library361.mjs";
import cloneTypedArray from "./component-library439.mjs";
import copyArray from "./component-library362.mjs";
import initCloneObject from "./component-library369.mjs";
import isArguments from "./component-library400.mjs";
import isArray from "./component-library293.mjs";
import isArrayLikeObject from "./component-library395.mjs";
import isBuffer from "./component-library370.mjs";
import isFunction from "./component-library402.mjs";
import isObject from "./component-library234.mjs";
import isPlainObject from "./component-library408.mjs";
import isTypedArray from "./component-library410.mjs";
import safeGet from "./component-library375.mjs";
import toPlainObject from "./component-library413.mjs";
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : void 0;
  var isCommon = newValue === void 0;
  if (isCommon) {
    var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack["delete"](srcValue);
  }
  assignMergeValue(object, key, newValue);
}
export {
  baseMergeDeep as default
};
